// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};

// 	jQ('.search-button').on('click', function() {
// 		setTimeout(function() {
// 			jQ('.boost-pfs-search-suggestion-wrapper, .boost-pfs-search-suggestion-mobile-overlay, .boost-pfs-search-suggestion-mobile-top-panel').remove();
// 			boostPFS.initSearchBox();
// 		}, 500);
// 	});

	InstantSearch.prototype.beforeInit = function () {
        jQ('#search-results').attr("style", "display: none !important");
    };
  
  // Bind Event for input search Mobile
  var bindEventsMobile = InstantSearchMobile.prototype.bindEvents;
  InstantSearchMobile.prototype.bindEvents = function() {
    bindEventsMobile.call(this);

    var self = this;

    jQ('.site-nav--mobile .search-button').off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ('.search-input-group input[type="search"]').focus();
      self.openSuggestionMobile();
      jQ('.drawer__close > button').trigger('click');

    });
  }
  
  // Bind Event for input search style 3
  var bindEvents = InstantSearchStyle3.prototype.bindEvents;
  InstantSearchStyle3.prototype.bindEvents = function() {
    bindEvents.call(this);

    var self = this;

    jQ('.site-header__links .search-button').off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ('#SearchContainer #search-input').focus();
      self.openSuggestionStyle3();
      jQ('.drawer__close > button').trigger('click');

    });
  }

})();
